// src/icons/MessageIcon.js
import React from 'react';

export default function MessageIcon({ size = 24, color = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block' }}
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 20l1.3 -3.9c-2.3 -3.4 -1.4 -7.9 2.1 -10.4c3.5 -2.5 8.6 -2.3 11.8 .5c3.3 2.8 3.7 7.3 1 10.5c-2.7 3.2 -7.6 4.2 -11.6 2.3l-4.7 1" />
    </svg>
  );
}
